// src/newDashboard/shared/partnerRef.js
//
// Remembers which sign-up link or QR code brought a bar owner or charity to
// the dashboard, e.g. portal.barfunfinder.com/signup?ref=emp-sarah
//
// captureRef() runs once when the dashboard opens. It keeps the code for
// 30 days in this browser, so it still counts if they sign up a few days
// later. Signup.jsx stamps it on the new account, and ClaimBar.jsx stamps
// it on the bar when they claim it.

import { doc, increment, setDoc } from "firebase/firestore";
import { db } from "../../firebase";

const KEY = "bff_partner_ref";
const KEEP_DAYS = 30;

function clean(raw) {
  return String(raw || "").toLowerCase().trim().replace(/[^a-z0-9-]/g, "").slice(0, 60);
}

export function refType(code) {
  if (code.startsWith("bar-")) return "bar";
  if (code.startsWith("emp-")) return "employee";
  return "campaign";
}

export function captureRef() {
  try {
    const code = clean(new URLSearchParams(window.location.search).get("ref"));
    if (!code) return;
    localStorage.setItem(KEY, JSON.stringify({ code, at: Date.now() }));
    // Count the visit on the link (ignored if it can't be saved).
    setDoc(doc(db, "referralCodes", code), { code, partnerScans: increment(1) }, { merge: true }).catch(() => {});
  } catch (e) {
    // Private browsing or storage blocked: just don't track.
  }
}

/** The saved code, or "" if none (or older than 30 days). */
export function savedRef() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!saved?.code) return "";
    if (Date.now() - saved.at > KEEP_DAYS * 24 * 60 * 60 * 1000) return "";
    return saved.code;
  } catch (e) {
    return "";
  }
}

/** Fields to add to a new owner/charity account. */
export function refFields() {
  const code = savedRef();
  return code ? { signupRef: code, signupRefType: refType(code), signupRefAt: new Date() } : {};
}
